// @mui
import { createTheme } from "@mui/material/styles";
// theme
import { Palette } from "theme/palette";
import { breakpoints } from "theme/breakpoints";
import { typography } from "theme/typography";
import { shape, spacing } from "theme/shape";
import { createShadow } from "theme/shadows";
import { transitions } from "theme/transitions";
import { components } from "theme/component-overrides";
import { faIR } from "@mui/x-date-pickers/locales";
// types
import type { ThemeDirectionTypes, ThemeModeTypes } from "theme/types";

interface ThemeOptionsTypes {
  mode?: ThemeModeTypes;
  direction?: ThemeDirectionTypes;
  customColors?: {
    primary?: string;
    secondary?: string;
  };
}

export const theme = (theme?: ThemeOptionsTypes) => {
  const palette = Palette(theme?.mode, theme?.customColors);
  const LIGHT_MODE = palette?.grey?.["600"] as string;
  const shadows = createShadow(LIGHT_MODE);

  return createTheme(
    {
      spacing,
      direction: theme?.direction,
      shape,
      typography,
      breakpoints,
      palette,
      shadows,
      components,
      transitions,
    },
    faIR
  );
};
